export const MODAL_ACTION_TYPES = {
  SET_MODAL_CATEGORY: 'SET_MODAL_CATEGORY',
  TOGGLE_MODAL: 'TOGGLE_MODAL', // Open and closes the whole thing
  OPEN_MODAL_TO_CATEGORY: 'OPEN_MODAL_TO_CATEGORY', // opens to certain category
  UPDATE_MODAL_FILTERS: 'UPDATE_MODAL_FILTERS', // updates modal filters
  CLEAR_ALL_MODAL_FILTERS: 'CLEAR_ALL_MODAL_FILTERS', // clears all modal filters
};
